import { getSeedingMeProposalCount as getSeedingMeProposalCountApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetSeedingMeProposalCountServiceResponse } from './get-seeding-me-proposal-count.dto';
import { GetSeedingMeProposalCountServiceResponseSchema } from './get-seeding-me-proposal-count.dto';

export const getSeedingMeProposalCountService = withServiceErrorCapture(
  lazyPipe(async (): Promise<GetSeedingMeProposalCountServiceResponse> => {
    const apiResponse = await getSeedingMeProposalCountApi();

    if (apiResponse.meta?.result === 'FAIL') {
      throw new Error(apiResponse.meta?.message ?? '제안 카운트 조회에 실패했습니다.');
    }
    return apiResponse.data;
  }, validateServiceResponse(GetSeedingMeProposalCountServiceResponseSchema)),
);
